export default function ReceiptTableSummary({
	translate,
	lang,
	date,
	id,
	name,
}) {
	return (
		<table style={{ marginTop: "25px" }}>
			<thead>
				<tr>
					<th style={{ width: "33%" }}>{translate(lang, `Fecha`, `Fecha`)}</th>
					<th>
						{translate(
							lang,
							`Número de Confirmación`,
							`Número de Confirmación`,
						)}
					</th>
					<th style={{ width: "33%" }}>
						{translate(lang, `Participante`, `Participante`)}
					</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td className="center">{date}</td>
					<td className="center">{id}</td>
					<td className="center">{name}</td>
				</tr>
			</tbody>
		</table>
	);
}
